import { getWindowConfig, } from '~/utils/env';
import { MoveOut, } from './move-out';

MoveOut('#app', (s) => getWindowConfig(s));
